module.exports = __webpack_public_path__ + "static/media/carp.madera.1c3b0834.svg";